import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { getTreasury, type TreasuryResponse } from "../lib/api.js";

export function Dashboard() {
  const [treasury, setTreasury] = useState<TreasuryResponse | null>(null);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    getTreasury()
      .then(setTreasury)
      .catch((e) => setErr(e.message));
  }, []);

  return (
    <div>
      <h1>SENTRY U2U</h1>
      <p className="muted">
        Six-hop TRON USDT → Railgun → TRON USDT. Mnemonics live only in
        your browser's memory; the Worker receives encrypted blobs.
      </p>

      <div className="panel">
        <h3>Treasury</h3>
        {err ? (
          <div className="error">Error loading treasury: {err}</div>
        ) : treasury === null ? (
          <div className="muted">Loading…</div>
        ) : treasury.configured === false ? (
          <div className="muted">
            Treasury is not initialized yet. Set the
            <code> TREASURY_TRON_ADDRESS </code>
            (and <code> TREASURY_TRON_PK </code>) Worker secrets to turn
            on fee accrual and balance reporting.
          </div>
        ) : (
          <div>
            <div className="muted">Address</div>
            <code>{treasury.tron_address}</code>
            <div style={{ marginTop: 12 }}>
              TRX: <strong>{treasury.trx_natural.toFixed(3)}</strong> —{" "}
              USDT: <strong>{treasury.usdt_natural}</strong>
            </div>
          </div>
        )}
      </div>

      <div className="panel">
        <Link to="/new-job">
          <button>Start a new job →</button>
        </Link>
      </div>
    </div>
  );
}
